export { default as ProductPropertyDS } from './product-property-ds'
export type { ProductPropertyDSProps } from './product-property-ds'
